// React
import { createContext } from "react"

// Types
import type { DataContextType } from "../types"

export const DataContext = createContext<DataContextType>({
  data: [],
  blankExample: {},
  example: {},
  list: [],
  assignData(_) {}
})